import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { AccountBasicData } from 'src/app/models/account/account-basic-data.model';
import { MasterService } from 'src/app/services/master.service';
import { DocumentType } from 'src/app/models/master/document-type.model';
import { ClientType } from 'src/app/models/account/client-type.model';
import { AccountService } from 'src/app/services/account.service';
import { Basic } from 'src/app/core/models/basic.model';

@Component({
  selector: 'client-section',
  templateUrl: './client-section.component.html',
  styleUrls: ['./client-section.component.scss']
})
export class ClientSectionComponent implements OnInit {
  /*Lista de tipos de documento */
  documentTypeList: DocumentType[] = [];
  /**Lista de tipos de cliente */
  clientTypeList: ClientType[] = [];
  NoClientTypeList: ClientType[] = [];
  clientType: string;
  selected: string;
  codDoc: string;
  tamanio: number;

  textoCorreo: string = '';
  @Output() textoCorreoCambiado = new EventEmitter<string>();


  /**Es cliente? */
  @Input() isClient: boolean;
  @Input() parent: string;
  mainTitle: string = '';
  //mainTitle: string = '';
  formGroup: FormGroup
  constructor(private formBuilder: FormBuilder,
    private masterService: MasterService,
    private accountServices: AccountService) { }

    onInputEmailChange(event: Event) {
      this.textoCorreo = (event.target as HTMLInputElement).value;
      this.textoCorreoCambiado.emit(this.textoCorreo);
    }

  ngOnInit() {
    this.createForm();
    this.modifyForm();
    this.listClientTypes();
    this.listDocumentTypes();

    if (this.isClient) this.formGroup.disable();
    this.mainTitle = this.parent == "service-request" ? "DATOS PRINCIPALES" : "DATOS RECLAMANTE";
  }

  createForm() {
    if (this.isClient) {
      this.formGroup = this.formBuilder.group({
        name: [, [Validators.required]],
        lastName: [, [Validators.required]],
        documentType: [, [Validators.required]],
        documentNumber: [, [Validators.required]],
        code: [],
        homePhone: [],
        cellPhone: [, [Validators.required]],
        email: [, [Validators.required]],
        type: [, [Validators.required]],
        interlocutorId: [],
        installationNumber: []
      }
      //, { validators: this.atLeastHomePhoneOrCellPhoneValidator }
      )

    }
    else {
      this.formGroup = this.formBuilder.group({
        name: [, [Validators.required, Validators.maxLength(40)]],
        lastName: [, [Validators.required, Validators.maxLength(40)]],
        documentType: [, [Validators.required, Validators.maxLength(10)]],
        documentNumber: [, [Validators.required]],
        code: [],
        homePhone: [],
        cellPhone: [, [, Validators.maxLength(240)]],
        email: [, [, Validators.maxLength(10)]],
        typeNoClient: [, [Validators.required]],
        interlocutorId: [],
        installationNumber: []
      }
      //, { validators: this.atLeastHomePhoneOrCellPhoneValidator }
      )
    }
  }

  get f() { return this.formGroup.controls; }

  modifyForm() {
    if (this.isClient) this.formGroup.get('email').setValidators([Validators.email])
    else this.formGroup.get('email').setValidators([, Validators.email]);
  }

  fillForm(accountBasicData: AccountBasicData) {
    this.formGroup.patchValue({
      name: accountBasicData.name,
      lastName: accountBasicData.lastName,
      documentType: accountBasicData.documentType,
      documentNumber: accountBasicData.documentNumber,
      homePhone: accountBasicData.homePhoneNumber,
      cellPhone: accountBasicData.cellPhoneNumber,
      email: accountBasicData.emailAddress,
      type: accountBasicData.clientType.code,
      interlocutorId: accountBasicData.interlocutorId,
      installationNumber: accountBasicData.installationNumber
    });
    if (this.isClient) {
      this.clientType = this.formGroup.get('type').value;
    }
    else {
      this.clientType = this.formGroup.get('typeNoClient').value;
    }
    this.accountServices.setTypeClient(this.clientType);
  }
  atLeastHomePhoneOrCellPhoneValidator(abstractControl: AbstractControl) {
    if (
      (abstractControl.get('homePhone').value != null
        && abstractControl.get('homePhone').value.toString().trim() != '')) {
      return null;
    } else return { homePhoneOrCellPhoneIsNeeded: true };
  }
  listDocumentTypes() {
    this.masterService.listDocumentTypes().subscribe(response => {
      this.documentTypeList = response.data;
    });
  }
  listClientTypes() {
    this.masterService.listClientTypes().subscribe(response => {
      this.clientTypeList = response.data;
      this.NoClientTypeList = response.data.filter(x => x.esNoCliente == true);
      if (!this.isClient) {

        this.formGroup.get('typeNoClient').setValue('RESU')
        this.formGroup.get('typeNoClient').disable()
      }
    })
  }
  select(item) {
    this.codDoc = item;
    console.log(item);
    this.formGroup.get('documentNumber').setValue('');
    if (this.codDoc == "PE2") {
      console.log(1);
      //this.formGroup.controls["documentNumber"].setValidators([Validators.required, Validators.maxLength(8)]);
      this.formGroup.get('documentNumber').setValidators([Validators.required, Validators.minLength(8), Validators.maxLength(8)]);
      this.tamanio = 8;
    } else if (this.codDoc == "PE1") {
      console.log(2);
      this.tamanio = 11;
      this.formGroup.controls["documentNumber"].setValidators([Validators.required, Validators.minLength(11), Validators.maxLength(11)]);
    }
    else if (this.codDoc == "PE3") {
      console.log(3);
      this.tamanio = 12;
      this.formGroup.controls["documentNumber"].setValidators([Validators.required, Validators.minLength(9), Validators.maxLength(12)]);
    } else if (this.codDoc == "PE5") {
      console.log(3);
      this.tamanio = 12;
      this.formGroup.controls["documentNumber"].setValidators([Validators.required, Validators.minLength(12), Validators.maxLength(12)]);
    }
    else {
      console.log(3);
      this.formGroup.controls["documentNumber"].setValidators([Validators.required, Validators.minLength(8), Validators.maxLength(12)]);
    }
    this.formGroup.controls["documentNumber"].updateValueAndValidity();
    console.log(this.formGroup);
  }
}
